import { c as _c } from "react/compiler-runtime";
import { Box } from "@navikt/ds-react";
import type { ReactNode } from "react";
interface Props {
  children: ReactNode;
}
export const AktivitetskravBox = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="max-w-3xl w-full"><Box shadow="dialog" background="default" padding="space-24" className="mx-4 mt-4 flex flex-col gap-4 rounded-lg">{children}</Box></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};